const SERVICE_WORKER_PATH = '/sw.js';
const CLEANUP_FLAG = 'pwa-sw-disabled-v1';

function shouldSkipRegistration() {
  if (import.meta.env.DEV) {
    return true;
  }

  if (!('serviceWorker' in navigator)) {
    return true;
  }

  return false;
}

export function registerServiceWorker() {
  if (shouldSkipRegistration()) {
    return;
  }

  window.addEventListener('load', () => {
    try {
      unregisterProjectServiceWorkers();
    } catch (error) {
      console.error('[PWA] Unable to clean service workers:', error);
    }
  });

  try {
    if (localStorage.getItem(CLEANUP_FLAG) !== '1') {
      unregisterProjectServiceWorkers().finally(() => {
        localStorage.setItem(CLEANUP_FLAG, '1');
      });
    }
  } catch (error) {
    // Non-blocking; legacy cleanup is best-effort only
    console.warn('[PWA] Cleanup of legacy service workers failed:', error);
  }
}

function unregisterProjectServiceWorkers() {
  return navigator.serviceWorker.getRegistrations().then((registrations) => {
    const projectRegistrations = registrations.filter(
      (registration) =>
        registration.active &&
        (registration.active.scriptURL.endsWith(SERVICE_WORKER_PATH) ||
          registration.active.scriptURL.includes('/service-worker.js')),
    );

    return Promise.all(projectRegistrations.map((registration) => registration.unregister()))
      .then(() => {
        if (!window.caches?.keys) {
          return undefined;
        }

        return caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key).catch(() => false))));
      })
      .then(() => undefined);
  });
}
